import ProfileContentSection from "@/components/profile-content-section";
import { AppearanceForm } from "./appearance-form";

export default function ProfileAppearance() {
  return (
    <ProfileContentSection
      title="Appearance"
      desc="Customize the appearance of the app. Automatically switch between day
          and night themes."
    >
      <AppearanceForm />
    </ProfileContentSection>
  );
}
